import DOMPurify, { Config } from 'dompurify';

export const getSafetyHtml = (html: string, options?: Config): string => {
    if (options) {
        return `${DOMPurify.sanitize(html, options)}`;
    }
    return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
};
